import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Solution',
    href: '#solution'
  }, {
    name: 'Market',
    href: '#market'
  }, {
    name: 'Investors',
    href: '#investors'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-950/80 backdrop-blur-md border-b border-slate-800 py-4' : 'bg-transparent py-6'}`} data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        <div className="flex items-center justify-between" data-id="element-197">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-198">
            <div className="p-2 bg-emerald-500/10 rounded-lg border border-emerald-500/20 group-hover:border-emerald-500/50 transition-colors" data-id="element-199">
              <Zap className="w-5 h-5 text-emerald-400" data-id="element-200" />
            </div>
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-201">
              Green Fuel
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-202">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-sm font-medium text-slate-300 hover:text-emerald-400 transition-colors" data-id="element-203">
                {link.name}
              </a>)}
            <a href="#investors" onClick={e => scrollToSection(e, '#investors')} className="px-5 py-2.5 text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-500 rounded-full transition-all hover:shadow-[0_0_20px_rgba(16,185,129,0.3)]" data-id="element-204">
              Invest Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-205">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-206" /> : <Menu className="w-6 h-6" data-id="element-207" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-slate-900 border-b border-slate-800 shadow-xl" data-id="element-208">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-209">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-base font-medium text-slate-300 hover:text-emerald-400 py-2" data-id="element-210">
                {link.name}
              </a>)}
            <a href="#investors" onClick={e => scrollToSection(e, '#investors')} className="mt-4 px-5 py-3 text-center text-base font-semibold text-white bg-emerald-600 rounded-lg" data-id="element-211">
              Invest Now
            </a>
          </div>
        </div>}
    </header>;
}